import React, { useState, useEffect } from 'react';
import Container from '@material-ui/core/Container';

import FirstBox from './FirstBox';
import FirstForm from './FirstForm';
import LoadingPage from '../LoadingPage';

import { contryListData } from '../../commons/testData';
import { fixCountries } from '../../commons/utils';
import { isvApi, API_URL } from '../../services/api';


const InitialForm = () => {
    const [countries, setCountries] = useState();
    const [isLoadingCountries, seIsLoadingCountries] = useState(true);

    useEffect(() => {
        if (!countries) {
            isvApi.get(API_URL.contries)
                .then(response => {
                    setCountries(fixCountries(response.data));
                })
                .catch(() => {
                    setCountries(contryListData);
                })
                .finally(() => seIsLoadingCountries(false));
        }
    }, [countries]);

    if (isLoadingCountries) {
        return <LoadingPage />
    } else {
        return (
            <>
                <br />
                <Container>
                    <div className="row">
                        <div className="col-lg-5 col-sm-12">
                            <FirstBox />
                        </div>
                        <div className="col-lg-7 col-sm-12">
                            <FirstForm countries={countries} />
                        </div>
                    </div>
                </Container>
            </>
        );
    }
};

export default InitialForm;
